import axios from 'axios'
import Raven from 'raven-js'
import store from '@/store'

// we don't use the default axios but a new instance with a different baseUrl
const authentificationAxios = axios.create({
  baseURL: '/api',
  withCredentials: true,
})

const loginUser = async data => {
  try {
    await authentificationAxios.post('/9.0/accounts/login/', data)
    // store.dispatch('Auth/authProcess')
  } catch (err) {
    store.commit('Auth/authError')
    throw err
  }
}

const logoutUser = async () => {
  try {
    const csrf = store.getters['Auth/csrf']
    await authentificationAxios.post('/7.0/accounts/logout/', {}, { headers: { 'X-CSRFToken': csrf } })
    store.commit('Auth/authLogout')
  } catch (err) {
    store.commit('Auth/authError')
    throw err
  }
}


// TODO: used only in offers, should be removed
const getUserData = async () => {
  try {
    const userData = await axios.get('/10.0/accounts/me/')
    return userData.data
  } catch (err) {
    Raven.captureException(err)
    store.dispatch('Alert/setAlert', { alert: 'Une erreur s\'est produite lors de la récupération des infos utilisateur', type: 'error' })
    store.dispatch('SnackBar/setSnack', { snack: 'Une erreur s\'est produite lors de la récupération des infos utilisateur', type: 'error' })
  }
}

const getUserAccountData = async () => {
  try {
    const userData = await axios.get('/10.0/accounts/me/')
    if (userData.data) {
      store.commit('Auth/setUserData', userData.data[0].fields)
      store.commit('Auth/authLogin')
    }
    return userData.data[0]
  } catch (err) {
    console.log(err)
    return null
  }
}

const getMangopayUserData = async () => {
  try {
    const mangopayUserData = await axios.get('/7.0/accounts/mangopay-user/')
    if (mangopayUserData.data) {
      store.commit('Auth/setMangopayUserData', mangopayUserData.data.fields)
    }
    return mangopayUserData.data
  } catch (err) {
    console.log(err)
    return null
  }
}



const setMobilePhone = async (phoneNumber) => {
  try {
    const userData = await axios.get('/10.0/accounts/me/')
    // eslint-disable-next-line camelcase
    const { email, last_name, first_name, birthday, nationality, residence_country_code, system } = userData.data[0].fields
    const form = new FormData()
    form.append('email', email)
    form.append('last_name', last_name)
    form.append('first_name', first_name)
    form.append('birthday', birthday)
    form.append('nationality', nationality)
    form.append('residence_country_code', residence_country_code)
    form.append('system', system)
    form.append('mobile_phone', phoneNumber)
    await axios({
      url: '/9.1/accounts/register/',
      method: 'PUT',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: form
    })
    return 'waiting'
  } catch (err) {
    if (err.response.status !== 400) {
      console.log(err)
      Raven.captureException(err)
    }
    throw err
  }
}

const checkMobilePhone = async (code) => {
  try {
    const form = new FormData()
    form.append('code', code)
    await axios({
      url: '/9.0/accounts/check-mobile-phone/',
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: form
    })
  } catch (err) {
    if (err.response.status !== 400) {
      console.log(err)
      Raven.captureException(err)
    }
    throw err
  }
}

const resendPhoneCode = async () => {
  try {
    const form = new FormData()
    await axios({
      url: '/8.1/accounts/resend-mobile-phone-validation-code/',
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: form
    })
  } catch (err) {
    if (err.response.status !== 400) {
      console.log(err)
      Raven.captureException(err)
    }
    throw err
  }
}

const deactivateAccount = async data => {
  try {
    await axios.post('/7.0/accounts/deactivate-account/', data)
  } catch (err) {
    if (err.response.status !== 400) {
      console.log(err)
      Raven.captureException(err)
    }
    throw err
  }
}

// const getUserSMSValidationRetries = async () => {
//   try {
//     const userData = await axios.get('/8.0/accounts/me/')
//     // eslint-disable-next-line camelcase
//     const retries = userData.data[0].fields.mobile_phone_to_verify_verification_retries
//     if (typeof retries === 'number'){
//       return 3 - retries
//     } else {
//       return `ERR: Format invalide - ${retries}`
//     }
//   } catch (err) {
//     if (err.response.status !== 400) {
//       console.log(err)
//       Raven.captureException(err)
//     }
//     throw err
//   }
// }

export {
  loginUser,
  logoutUser,
  getUserData,
  getUserAccountData,
  getMangopayUserData,
  setMobilePhone,
  checkMobilePhone,
  resendPhoneCode,
  deactivateAccount
}
